import FaIcon, { type FaIconProps } from '../FaIcon/FaIcon'

const DynamicFaIcon = (props: FaIconProps) => {
    return <FaIcon {...props} />
}

export default DynamicFaIcon
